import { PageType } from "~/lib/router/enums";

export const pathname = "/posties/parents";

export const page = {
  route(query: QueryParameters) {
    return { cacheMaxAge: 60, pathname, query: { ...query, pageType: PageType.PostiesParents } };
  },
};
